import * as Yup from "yup";

export const formValidationPersonal = Yup.object().shape({
    Customer_name: Yup.string().required("Full Name is required !")
});
